// extracted by mini-css-extract-plugin
export default {"skeleton__head":"styles_skeleton__head__QaZl-","skeleton__column":"styles_skeleton__column__dLM4E","table__skeleton":"styles_table__skeleton__p66SE"};